import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IUserMentionData } from '@gem/models/commonModel';
import { useTranslation } from '@gem/modules/i18n';
import { Link } from '@gem/ui-kit';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';

import { useSeeMoreDescriptionPresenter } from './ProfileSeeMoreDescription.presenter';
import styles from './ProfileSeeMoreDescription.styles.m.css';

interface IProfileSeeMoreDescriptionProps {
  className?: string;
  description: string;
  mentions?: IUserMentionData[];
  groupId?: string;
}

export const ProfileSeeMoreDescription: FC<IProfileSeeMoreDescriptionProps> = observer(
  ({ className, description, mentions, groupId }) => {
    const { t } = useTranslation();
    const presenter = useSeeMoreDescriptionPresenter(description);

    return (
      <div className={className}>
        <TextRenderer
          userMentions={mentions}
          groupId={groupId}
        >
          {presenter.description}
        </TextRenderer>
        <Link
          className={classNames(styles.link, styles.showMore, {
            [styles.hide]: !presenter.isMoreButton,
          })}
          onClick={presenter.showMore}
        >
          {t('group_description_more')}
        </Link>
      </div>
    );
  }
);
